import { render, staticRenderFns } from "./RespostaCheckbox.vue?vue&type=template&id=21b4b52f"
import script from "./RespostaCheckbox.vue?vue&type=script&lang=js"
export * from "./RespostaCheckbox.vue?vue&type=script&lang=js"
import style0 from "./RespostaCheckbox.vue?vue&type=style&index=0&id=21b4b52f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports